
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/amazon-athena",
      function () {
        return require("private-next-pages/sources/amazon-athena.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/amazon-athena"])
      });
    }
  